import { toaster as customersToaster } from "@hydrologiq/shared/chakra/Toaster"

// Export the toaster instance for testing
export { customersToaster }

export const showSuccessToast = (title: string, description?: string) => {
  customersToaster.create({
    title,
    description,
    type: "success",
    duration: 4000,
  })
}

export const showErrorToast = (title: string, description?: string) => {
  customersToaster.create({
    title,
    description,
    type: "error",
    duration: 6000,
  })
}

export const showLoadingToast = (title: string, description?: string) => {
  return customersToaster.create({
    title,
    description,
    type: "loading",
  })
}

export const showWarningToast = (title: string, description?: string) => {
  customersToaster.create({
    title,
    description,
    type: "warning",
    duration: 5000,
  })
}

export const dismissToast = (id?: string) => {
  if (id) {
    customersToaster.dismiss(id)
  } else {
    customersToaster.dismiss()
  }
}
